/*  ========================================================================
    # Vendors - Smooth-Scroll
    ========================================================================  */

/**
 * Adds smooth scrolling to the page.
 * {@link https://github.com/cferdinandi/smooth-scroll}
 */

import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[href*="#"]', {
  // Selectors
  ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector).
  header: null, // Selector for fixed headers (must be a valid CSS selector).
  topOnEmptyHash: true, // Scroll to the top of the page for links with href="#".

  // Speed & Easing
  speed: 250, // Integer. Amount of time in milliseconds it should take to scroll 1000px.
  speedAsDuration: true, // If true, use speed as the total duration of the scroll animation.
  durationMin: null, // Integer. The minimum amount of time the scroll animation should take.
  durationMax: null, // Integer. The maximum amount of time the scroll animation should take.
  clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page.
  offset: 0, // How far to offset the scrolling anchor location in pixels.
  easing: 'easeInOutCubic', // Easing pattern to use.

  // History
  updateURL: false, // Update the URL on scroll.
  popstate: false, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true).

  // Custom Events
  emitEvents: true // Emit custom events.
});
